export default "__VITE_ASSET__BzvN2ZI6__"